export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 6_13.fe9fce05.jpg";